import { Box, CircularProgress } from '@mui/material';
import React from 'react';

const Spinner = (props: { size?: number; centered?: boolean }) => {
  const spinnerSize = props.size || 40;

  const parentStyles: React.CSSProperties = props.centered
    ? { position: 'relative', height: '100%' }
    : {};
  const spinnerStyles: React.CSSProperties = props.centered
    ? {
        position: 'absolute',
        top: `calc(50% - ${spinnerSize / 2}px)`,
        left: `calc(50% - ${spinnerSize / 2}px)`,
      }
    : {};

  return (
    <Box style={parentStyles}>
      <CircularProgress size={spinnerSize} style={spinnerStyles} />
    </Box>
  );
};

export default Spinner;
